import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class GetActiveArcDatesArgs {
  @Field(t => Int, { nullable: true })
  excludeArcId?: number
}
